import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node.isRequired,
  layout: PropTypes.elementType.isRequired,
};

function PublicRoute({ children, layout: Layout }) {
  return <Layout>{children}</Layout>;
}

PublicRoute.propTypes = propTypes;

export default PublicRoute;
